import { createSlice } from "@reduxjs/toolkit";
import { fechVKYCDataByPrimaryWorkflowId, sendVKYCReminderToUser } from "api/dashboardDetail";

const initialState = {
  vkycResponse: {},
  vkycResponseOfAllSubWorkFlows: [],
  vkyCResponseLoading: false,
  doesAnySubWorkflowHasVkyc: false,
  vkyCQueue: [],
  vkycStatus: [],
  vkycActiveStep: [],
  sendReminderLoading: false,
  successFullySentVKYCREminderToUser: false,
  failedToSendVKYCREminderToUser: false,
  sentToUser: '',
  uploadedDoc: "",
};

export const vkycReducer = createSlice({
  name: "vkycCallback",
  initialState,
  reducers: {
    setVkycResponse: (state, action) => {
      state.vkycResponse = action.payload;
    },
    clearToastMessagesState: (state, action) => {
      state.successFullySentVKYCREminderToUser = false;
      state.failedToSendVKYCREminderToUser = false;
    },
    setFailedToSendVKYCREminderToUser: (state, action) => {
      state.failedToSendVKYCREminderToUser = true;
    },
    setUploadedDoc: (state, action) => {
      state.uploadedDoc = action.payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fechVKYCDataByPrimaryWorkflowId.rejected, (state, action) => {
        state.vkyCResponseLoading = false;
      })
      .addCase(fechVKYCDataByPrimaryWorkflowId.pending, (state, action) => {
        state.vkyCResponseLoading = true;
        state.vkycResponseOfAllSubWorkFlows = [];
        state.vkyCQueue = [];
        state.vkycStatus = [];
        state.vkycActiveStep = [];
      })
      .addCase(fechVKYCDataByPrimaryWorkflowId.fulfilled, (state, action) => {
        state.doesAnySubWorkflowHasVkyc = action.payload && action.payload.some(
          (item) => item?.vkyc_response
        );
        state.vkyCResponseLoading = false;
        let queue = [];
        action.payload?.forEach((item) => {
          if (item?.vcip_response) {
            queue.push(item?.vcip_response);
          } else if(!item?.vcip_response) {
            queue.push(null);
          }
          state.vkyCQueue = [...queue];
          if (item?.vcip_callback) {
            state.vkycResponseOfAllSubWorkFlows = [
              ...state.vkycResponseOfAllSubWorkFlows,
              item?.vcip_callback,
            ];
          } else if (!item?.vcip_callback) {
            state.vkycResponseOfAllSubWorkFlows = [
              ...state.vkycResponseOfAllSubWorkFlows,
              null,
            ];
          }
          if (item?.status) {
            state.vkycStatus = [...state.vkycStatus, item?.status];
          }
          if (item?.active_step) {
            state.vkycActiveStep = [...state.vkycActiveStep, item?.active_step];
          }
        });
      });

    builder
      .addCase(sendVKYCReminderToUser.pending, (state, action) => {
        state.sendReminderLoading = true;
        state.successFullySentVKYCREminderToUser = false;
        state.failedToSendVKYCREminderToUser = false;
      })
      .addCase(sendVKYCReminderToUser.fulfilled, (state, action) => {
        state.sendReminderLoading = false;
        state.sentToUser = action.payload.userName
        state.successFullySentVKYCREminderToUser = true;
      })
      .addCase(sendVKYCReminderToUser.rejected, (state, action) => {
        state.sendReminderLoading = false;
        state.failedToSendVKYCREminderToUser = true;
      });
  },
});

export const { setVkycResponse, clearToastMessagesState, setFailedToSendVKYCREminderToUser, setUploadedDoc } = vkycReducer.actions;

export default vkycReducer.reducer;
